jQuery(function(){
    var $table = jQuery('#transactions-table');

    // Load more data into table
    jQuery('body').on('click', '#account-load-more', function(e) {

        var get = {};

        var records = $table.find('.table__row').length;
        get.offset = records;

        jQuery.get('/api/get_transactions', get, function(response){

            $table.find('tbody').append(response);

            if( $table.find('.account-table__no-more-results').length === 1) {
                jQuery('.account-table-card__content').find('.table__load-more').hide();
            }

        });

        return false;
    });

});
